export default __webpack_public_path__ + "static/media/5.3027bd87.svg";